import { Component } from '@angular/core';

@Component({
    selector: 'app-nav-profile',
    templateUrl: './nav-profile.component.html',
    styleUrls: ['./nav-profile.component.css']
})
/** nav-profile component*/
export class NavProfileComponent {
    /** nav-profile ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/ui-components/nav-profile/nav-profile.component.ts